import { Link } from 'react-router-dom';

import styles from './Config.module.css';

interface ConfigCard {
  title: string;
  description: string;
  to: string;
  state: string;
  disabled?: boolean;
}

interface ConfigSection {
  label: string;
  cards: ConfigCard[];
}

const SECTIONS: ConfigSection[] = [
  {
    label: 'Operação',
    cards: [
      {
        title: 'Geral',
        description:
          'Aparência, persona default, timezone, versão e estado do sistema.',
        to: '/config',
        state: 'pós-MVP',
        disabled: true,
      },
      {
        title: 'Utilizadores',
        description:
          'Equipa com acesso ao Wiredesk OS. Criar, desativar e repor senha. Login por e-mail, troca no 1º acesso.',
        to: '/config/usuarios',
        state: 'MVP',
      },
      {
        title: 'Marca',
        description:
          'White-label em runtime: nome, logo, cor e tagline. Aplica na hora, sem rebuild. Onboarding de cliente novo sem cirurgia.',
        to: '/config/marca',
        state: 'S0',
      },
      {
        title: 'Sites WordPress',
        description:
          'Multi-site WP: URL, app password, default author, test connection.',
        to: '/config/sites',
        state: 'S23',
      },
      {
        title: 'AI Providers',
        description:
          'OpenAI, Anthropic, Gemini, Perplexity. Default model + budget mensal.',
        to: '/config/ai-providers',
        state: 'S23',
      },
    ],
  },
  {
    label: 'Inteligência',
    cards: [
      {
        title: 'Fluxo de Quentes',
        description:
          'Esteira automática: rankeia tendências, enriquece (PAA + N fontes), escreve com IA e publica no WP. Editorias, tetos, corte de score e rascunho↔publicado.',
        to: '/config/quentes',
        state: 'MVP',
      },
      {
        title: 'Templates de Horóscopo',
        description:
          'O padrão diário de publicações (7 tipos): rótulo, regex que casa o título e estrutura-padrão do conteúdo.',
        to: '/config/horoscopo',
        state: 'MVP',
      },
    ],
  },
  {
    label: 'Integrações',
    cards: [
      {
        title: 'APIs externas',
        description:
          'SERP API, SMTP, Twitter/X, FreeAstrology — credenciais e configs específicas.',
        to: '/config/external-apis',
        state: 'S23',
      },
      {
        title: 'Prompts',
        description:
          'Templates de prompt versionados por workflow (Axioma IV — engenharia travada).',
        to: '/config/prompts',
        state: 'S7/S8',
      },
      {
        title: 'Notificações',
        description:
          'Subscrições por persona + canais email / webhook / in-app.',
        to: '/config/notificacoes',
        state: 'S10',
      },
    ],
  },
  {
    label: 'Auditoria & Limites',
    cards: [
      {
        title: 'Audit log',
        description:
          'Registo append-only de todas as mutações (REST + MCP). Axioma V.',
        to: '/config/audit',
        state: 'S15',
      },
      {
        title: 'Custos & limites',
        description:
          'Gasto mensal por provider, budgets, alertas a 80% / 100%, histórico de 6 meses.',
        to: '/config/custos',
        state: 'S23',
      },
      {
        title: 'Credenciais',
        description:
          'Vista master de todas as API keys (Fernet-encrypted). Reveal + rotate audit-logged.',
        to: '/config/credenciais',
        state: 'S23',
      },
    ],
  },
];

export function Config() {
  return (
    <section className={styles.root}>
      <header className={styles.header}>
        <h1 className={styles.title}>Configurações</h1>
        <p className={styles.subtitle}>
          Pontos únicos de configuração do sistema. Tudo o que muda
          comportamento ao vivo vive aqui — secrets ficam encriptados em DB.
        </p>
      </header>

      {SECTIONS.map((section) => (
        <div key={section.label} className={styles.section}>
          <h2 className={styles.sectionLabel}>{section.label}</h2>
          <div className={styles.grid}>
            {section.cards.map((card) =>
              card.disabled ? (
                <div
                  key={card.title}
                  className={`${styles.card} ${styles.cardDisabled}`}
                  aria-disabled
                >
                  <div className={styles.head}>
                    <span className={styles.cardTitle}>{card.title}</span>
                  </div>
                  <p className={styles.desc}>{card.description}</p>
                  <span className={styles.state}>{card.state}</span>
                </div>
              ) : (
                <Link
                  key={card.title}
                  to={card.to}
                  className={styles.card}
                >
                  <div className={styles.head}>
                    <span className={styles.cardTitle}>{card.title}</span>
                  </div>
                  <p className={styles.desc}>{card.description}</p>
                  <span className={styles.state}>{card.state}</span>
                </Link>
              ),
            )}
          </div>
        </div>
      ))}
    </section>
  );
}
